import styled from 'styled-components';

export const RecallCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgb(24 53 88 / 10%);
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
`;
export const RecallChevronIconWrapper = styled.span`
  display: flex;
  flex-direction: row;
  padding-top: 6px;
`;

export const RecallCardHeaderContainer = styled.div`
  padding: 20px 24px;
  display: flex;
  align-items: center;
`;

export const RecallIconWrapper = styled.div`
  margin-right: 16px;
  height: 32px;
  display: flex;
`;

export const RecallCardHeader = styled.div`
  font-family: Brandon Text;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: var(--cvna-color-blue-6);
`;
export const RecallCardContentContainer = styled.div`
  font-family: Brandon Text;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
  padding: 0 24px;
  display: flex;
`;
export const HeaderButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: none;
  outline: none;
  border-color: none;
  background: #ffffff;
  margin-left: 0;
  padding: 0;
  width: 100%;
  cursor: pointer;

  &:focus {
    outline: none;
    outline: 0px auto -webkit-focus-ring-color;
  }

  &:hover {
    border: none;
    outline: none;
    border-color: none;
    background: #ffffff;
    box-shadow: 0 0 0 0px white, 0 0 0 0px #ffffff;
  }
`;

export const RecallHeaderContainer = styled.div`
  width: 100%;
`;

export const AlertHeader = styled.div`
  align-items: center;
  color: ${(props) => props.theme.color.primary.v600};
  border: 8px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 16px;
  border-radius: 8px 8px 0 0;
  display: flex;
  background: #fff5f5;

  span {
    margin-left: 4px;
  }

  // For Tablets and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    padding: 12px 16px;
  }
`;

export const NoOpenRecallWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;

export const HR = styled.hr`
  border: 1px solid var(--cvna-color-grey-2);
  border-bottom-color: transparent;
  margin: 0;
`;

export const RecallSubtextWrapper = styled.div`
  padding: 16px 24px 24px;
`;

export const RecallSubtext = styled.p`
  color: #697184;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin: 0;

  @media (min-width: 768px) {
    margin-top: 0;
  }
`;

export const RecallTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  font-feature-settings: 'liga' off;
  color: #6d7184;
  text-transform: capitalize;
`;
